export default {
  pageTitle: 'Seleccione uma organização:',
};
